import React from "react";
import { Typography, Button, Box } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";

const Success = ({ title, message, onClick, smallHeightLaptop }) => {
   const navigate = useNavigate();

   const handleBackToLogin = () => {
      if (onClick) onClick();
      else navigate("/login");
   };

   return (
      <Box
         sx={{
            minHeight: "100vh",
            backgroundColor: "#F0F2F5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            px: 2,
         }}
      >
         {/* White Card */}
         <Box
            sx={{
               backgroundColor: "#FFFFFF",
               borderRadius: "24px",
               boxShadow: "0px 8px 40px rgba(0,0,0,0.08)",
               width: { xs: "100%", sm: "480px" },
               px: { xs: 4, sm: 6 },
               py: { xs: 6, sm: 8 },
               display: "flex",
               flexDirection: "column",
               alignItems: "center",
               gap: 2,
               textAlign: "center",
            }}
         >
            {/* Blue Circle Checkmark */}
            <Box
               sx={{
                  backgroundColor: "#3B63F7",
                  borderRadius: "50%",
                  width: 64,
                  height: 64,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: 1,
               }}
            >
               <CheckCircleIcon sx={{ fontSize: 36, color: "#FFFFFF" }} />
            </Box>

            {/* Title */}
            <Typography
               sx={{
                  fontFamily: "'Space Grotesk', sans-serif",
                  fontWeight: 700,
                  fontSize: "26px",
                  color: "#111827",
               }}
            >
               {title || "Success!"}
            </Typography>

            {/* Message */}
            <Typography
               sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 400,
                  fontSize: "15px",
                  color: "#0F172A",
                  mb: 1,
               }}
            >
               {message || "Your account has been created"}
            </Typography>

            {/* Button */}
            <Button
               variant="contained"
               onClick={handleBackToLogin}
               fullWidth
               sx={{
                  fontFamily: "'Poppins', sans-serif",
                  fontWeight: 500,
                  textTransform: "none",
                  backgroundColor: "#3B63F7",
                  borderRadius: "10px",
                  py: 1.4,
                  fontSize: "15px",
                  boxShadow: "none",
                  mt: 1,
                  "&:hover": {
                     backgroundColor: "#2A52D4",
                     boxShadow: "none",
                  },
               }}
            >
               Back to Login
            </Button>
         </Box>
      </Box>
   );
};

export default Success;